import $ from 'jquery';
import scrollMonitor from 'scrollmonitor';
import analytics from '../../services/analytics_service';
import config from '../../config';

export default () => {
    if (config.get('featureFlags.piwikEnabled') === true) {
        const $document = $(document);
        const setUpClickEvents = (conf) => {
            const { selector, name } = conf;
            $document.on('click', selector, function () {
                // console.log(name);
                analytics.trackClick(name, document.location.href);
            });
        };

        [
            {
                selector: '.the-latest-list',
                name: 'the_latest_homepage'
            }
        ].forEach(setUpClickEvents);

        const setUpTrackInView = (conf) => {
            const { selector, name } = conf;
            const elementWatcher = scrollMonitor.create($(selector));
            elementWatcher.enterViewport(function () {
                // console.log(name);
                analytics.trackInView(name, document.location.href);
            });
        };

        [{
            selector: '.top-stories-module',
            name: 'top_stories_homepage'
        }, {
            selector: '.people-are-reading',
            name: 'people_are_reading'
        }, {
            selector: '.newsletter',
            name: 'newsletter'
        }, {
            selector: '.more-from-our-sites',
            name: 'more_from_our_sites'
        }, {
            selector: '.fc-studios',
            name: 'fc_studios'
        }, {
            selector: '.from-the-issue',
            name: 'from_this_months_issue'
        }].forEach(setUpTrackInView);
    }
};
